import { AgGridReact } from 'ag-grid-react';
import "ag-grid-community/styles/ag-grid.css"; // Core grid CSS, always needed
import "ag-grid-community/styles/ag-theme-alpine.css"; // Optional theme CSS
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';

const DataTable = ({
    data: customData,
    height,
    headerColumns,
    handleSelect = null,
    handleDelete = null,
    loading = false,
  }) => {
    const gridRef = useRef(null);
    const [rowData, setRowData] = useState([]);
    const [columnDefs, setColumnDefs] = useState([]);
    const defaultColDef = useMemo(
      () => ({
        minWidth: 100,
        flex: 1,
        sortable: true,
        resizable: true,
      }),
      []
    );
  
    const fillOutTable = async () => {
      const newColumns = headerColumns.map((col, i) => ({
        field: col.ref,
        headerName: col.value,
        pinned: i < 1 ? "left" : null,
        cellStyle: () => {
          if (i === 0 || i === 1) return null;
          return {
            textAlign: "left",
          };
        },
        onCellClicked: (params) => {
          if (handleSelect) {
            handleSelect(params);
          }
        },
      }));
      if(handleDelete){
        newColumns.push({
          field: "",
          pinned: "right",
          cellRenderer: (params) => (
            <button onClick={(e) => {
              e.preventDefault()
              e.stopPropagation();
              handleDelete(params)
            } }>Eliminar</button>
          ),
          width: 100,
        })
      }
      setRowData(data);
      setColumnDefs(newColumns);
    };
  
    useEffect(() => {
      data?.length && fillOutTable();
      if (data?.length === 0) {
        gridRef.current?.api?.setGridOption('rowData', [])
      }
      // eslint-disable-next-line
    }, [customData]);
  
    const data = useMemo(() => {
      return customData;
    }, [customData]);
  
    const onBtnExport = useCallback(() => {
      gridRef.current?.api.exportDataAsCsv();
    }, []);

    return (
      <>
        <div
          className="ag-theme-alpine-dark"
          style={{ width: "100%", height: height + "px" }}
        >
          <AgGridReact
          
           immutableData={true}
        
            ref={gridRef}
            rowData={rowData}
            columnDefs={columnDefs}
            defaultColDef={defaultColDef}
            rowSelection="multiple"
            tooltipShowDelay={300}
            suppressFieldDotNotation={true}
            suppressMovableColumns={true}
            animateRows={true}
            overlayLoadingTemplate={
              loading
                ? '<span class="ag-overlay-loading-center">Cargando...</span>'
                : null
            }
          />
          <div style={{ margin: "10px 0" }}>
            <button onClick={onBtnExport}>Download CSV export file</button>
          </div>
        </div>
      </>
    );
  };

  export default DataTable